<template>
    <div
        class="finance-options"
        data-qa="finance-options"
    >
        <AffirmWidget
            v-if="affirm"
            :refresh-key="Number(affirm.price.amount) * 100"
        >
            <p
                :data-amount="Number(affirm.price.amount) * 100"
                class="title affirm-as-low-as"
                data-page-type="product"
                data-qa="affirm"
            ></p>
        </AffirmWidget>

        <div
            v-if="klarna"
            class="klarna"
        >
            <I18n
                class="title"
                keypath="financeOptions.title"
                tag="p"
            >
                <template #perMonth>
                    <Money
                        :data="klarna.perMonth"
                        :formatter
                    />
                </template>

                <template #provider>
                    <span class="klarna-badge">Klarna</span>
                </template>
            </I18n>
        </div>
    </div>
</template>

<script lang="ts" setup>
import type {
    AffirmFinanceOptionsFragment,
    KlarnaFinanceOptionsFragment,
} from '@/graphql/api'

import Money from '@/components/Money.vue'
import AffirmWidget from '@/components/rings/AffirmWidget.vue'
import { useMoneyFormatter } from '@/plugins/money-formatter.ts'

defineProps<{
    affirm: AffirmFinanceOptionsFragment | null | undefined
    klarna: KlarnaFinanceOptionsFragment | null | undefined
}>()

const formatter = useMoneyFormatter()
</script>

<style lang="scss" scoped>
.finance-options {
    .affirm-badge {
        background: url('@/assets/icons/affirm.svg') no-repeat;
        background-size: contain;
        display: inline-block;
        vertical-align: text-bottom;
        @include visually-hidden-text;

        height: 21px;
        width: 60px;
        margin-bottom: 10px;
    }

    .klarna-badge {
        background: url('@/assets/icons/klarna.svg') no-repeat;
        background-size: contain;
        display: inline-block;
        vertical-align: text-bottom;
        @include visually-hidden-text;

        height: 21px;
        width: 60px;
    }
}
</style>
